import { z } from 'zod';
import { USER_ROLES } from '../constants.js';
import { emailSchema, nifSchema, passwordSchema, phoneSchema } from './auth.schema.js';

export const adminUserCreateSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  firstName: z.string().min(1, 'Nome obrigatório').max(100),
  lastName: z.string().min(1, 'Apelido obrigatório').max(100),
  phone: phoneSchema,
  role: z.enum(USER_ROLES),
  isActive: z.boolean().optional().default(true),
});

export const userUpdateSchema = z.object({
  firstName: z.string().min(1).max(100).optional(),
  lastName: z.string().min(1).max(100).optional(),
  phone: phoneSchema,
  nif: nifSchema,
});

export const adminUserUpdateSchema = z.object({
  firstName: z.string().min(1).max(100).optional(),
  lastName: z.string().min(1).max(100).optional(),
  email: emailSchema.optional(),
  phone: phoneSchema,
  role: z.enum(USER_ROLES).optional(),
  isActive: z.boolean().optional(),
});

export const adminResetPasswordSchema = z.object({
  newPassword: passwordSchema,
});

export const userListQuerySchema = z.object({
  role: z.enum(USER_ROLES).optional(),
  scope: z.enum(['customers', 'staff']).optional(),
  search: z.string().optional(),
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});

export type UserUpdateInput = z.infer<typeof userUpdateSchema>;
export type AdminUserCreateInput = z.infer<typeof adminUserCreateSchema>;
export type AdminUserUpdateInput = z.infer<typeof adminUserUpdateSchema>;
export type AdminResetPasswordInput = z.infer<typeof adminResetPasswordSchema>;
export type UserListQuery = z.infer<typeof userListQuerySchema>;
